var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-nav-bar',{staticClass:"van-nav-bar--fixed",staticStyle:{"box-shadow":"0 1px 5px rgba(233,233,233,0.8)"},attrs:{"title":_vm.barTitle,"left-text":"返回","left-arrow":""},on:{"click-left":_vm.onClickLeft}})}
var staticRenderFns = []

export { render, staticRenderFns }